import {
  GetStartedWithModuleData,
  GetStartedWithVariantsType,
  UseGetStartedWith,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "getStartedWithModule";

const useGetStartedWithModule: UseGetStartedWith = () => {
  const { isLoading, value } = useMonarchRule<{
    data: GetStartedWithModuleData;
    variantCustomId: GetStartedWithVariantsType;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
    };
  }

  const { data } = value || {};
  const { filtersSection, resultsSection } = data || {};

  const variant = data?.isVisible ? "test" : "control";

  return {
    isLoading,
    variant,
    data: {
      isVisible: data?.isVisible ?? false,
      filtersSection,
      resultsSection,
    },
  };
};

export default useGetStartedWithModule;
